import React, { useState } from 'react';
import './App.css';

function App() {
  // State to manage passcode entry and authentication status
  const [passcode, setPasscode] = useState('');
  const [authenticated, setAuthenticated] = useState(false);

  // Handle the passcode input change
  const handlePasscodeChange = (event) => {
    setPasscode(event.target.value);
  };

  // Check passcode and authenticate user
  const handleLogin = () => {
    if (passcode === 'love') {
      setAuthenticated(true);  // Show the main page if the passcode is correct
    } else {
      alert('Incorrect passcode!');  // Alert if the passcode is incorrect
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        {!authenticated ? (
          // If not authenticated, show the passcode form
          <div>
            <h1>Enter the passcode to access the secret place</h1>
            <input
              type="password"
              value={passcode}
              onChange={handlePasscodeChange}
              placeholder="Enter passcode"
            />
            <button onClick={handleLogin}>Login</button>
          </div>
        ) : (
          // If authenticated, show the main content
          <div>
            <h1>Welcome to Chenqi's secret place</h1>
            <p>If your last name is Han, click this:</p>
            <button onClick={() => alert("Hello, I love you Han Lu!")}>Click Me</button>

            {/* Show the image after authentication */}
            <div>
              <img 
                src={`${window.location.href}self.jpg`}  // Replace with your CloudFront URL
                alt="Secret Image"
                style={{ width: '400px', height: 'auto', marginTop: '20px' }}  // Style the image
              />
            </div>
          </div>
        )}
      </header>
    </div>
  );
}

export default App;
